import { SnifferUrls } from '@zoomcatalog/design-system'
import { Module } from 'vuex'
import { EventPayload } from '@/ts-definitions'
import { RootStore } from '../rootStore'

export interface SnifferStore {
	endpoints: Partial<SnifferUrls>
}

type SnifferNamespace = 'sniffer'

type SetServicesEndpointsMutation = EventPayload<
	`${SnifferNamespace}/setServicesEndpoints`,
	Partial<SnifferUrls>
>

type SetProductLibraryEndpointMutation = EventPayload<
	`${SnifferNamespace}/setProductLibraryEndpoint`,
	'production' | 'beta' | 'alpha' | null
>

export type SnifferMutations =
	| SetServicesEndpointsMutation
	| SetProductLibraryEndpointMutation

export const snifferStore: Module<SnifferStore, RootStore> = {
	namespaced: true,
	state: {
		endpoints: {},
	},
	mutations: {
		setServicesEndpoints(state, { payload }: SetServicesEndpointsMutation) {
			state.endpoints = payload
		},
		setProductLibraryEndpoint(
			state,
			{ payload }: SetProductLibraryEndpointMutation
		) {
			const subdomainPrefix =
				payload === 'production' ? '' : payload === 'beta' ? 'beta-' : 'dev-'

			state.endpoints.PRODUCT_LIBRARY_API_ENDPOINT =
				state.endpoints.PRODUCT_LIBRARY_API_ENDPOINT?.replace(
					/[\w-]+library/,
					`${subdomainPrefix}library`
				)
		},
	},
}
